var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3AirHumidity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 38h-4a23 23 0 10-46 0h-4a27 27 0 1154 0zm-35 3.5a8 8 0 0016 0c0-5.36-6.5-10.86-8-17-1.5 6.14-8 11.64-8 17z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Air_humidity.ba38a314.svg";
export { SvgB3AirHumidity as ReactComponent };